import { FormattedMessage } from 'react-intl';
import { SITE_CATEGORY } from '../../config/sites';
import { BillingType as BillingTypes } from '../../modules/commonTypes';
import EllipsisText from '../EllipsisText';
import messages from './messages';

interface IBillingType {
  billingType: BillingTypes;
  siteCategory?: SITE_CATEGORY;
}

export function BillingType({ billingType, siteCategory }: IBillingType) {
  if (siteCategory === SITE_CATEGORY.ACCESS_COMMANDER_REMOTE) {
    return '–';
  }

  return (
    <EllipsisText>
      <FormattedMessage
        {...(billingType === BillingTypes.PER_APARTMENT
          ? messages.sitesDataGridColumnsPaymentModelPerApartment
          : messages.sitesDataGridColumnsPaymentModelPerDevice)}
      />
    </EllipsisText>
  );
}
